import { render, staticRenderFns } from "./commend.vue?vue&type=template&id=6e23428e&scoped=true&"
import script from "./commend.vue?vue&type=script&lang=js&"
export * from "./commend.vue?vue&type=script&lang=js&"
import style0 from "./commend.vue?vue&type=style&index=0&id=6e23428e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e23428e",
  null
  
)

export default component.exports